import React, { useState, useEffect } from 'react';
import FieldDTO from '../../../../../components/fields/Abstract/FieldDTO';
import CustomSelectInput from '../../../../../components/fields/SelectInput/CustomSelectInput';
import {
  PROCEDURE_TYPE, USER_TYPE, VEHICLE_REGISTRY_BASIS_LIST, VEHICLE_REGISTRY_BASIS_TYPE,
} from '../../../../../configs';
import { Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';

export default function VehicleRegistryBasisForm(props) {
  const {
    prefix = 'applicant_new.',
    control,
    formMeta,
    applicantType,
    procedure,
    watch,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const [showVehicleRegistry, setVehicleRegistry] = useState(
    isEdit ? !!currentApplication?.applicant_new?.score_localization || currentApplication?.applicant_new?.score_localization === null : false,
  );

  useEffect(() => {
    const subscription = watch(values => {
      setVehicleRegistry(values?.applicant_exemption === VEHICLE_REGISTRY_BASIS_TYPE.EXEMPTION_3);
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  useEffect(() => {
    setValue('applicant_new.score_localization', !showVehicleRegistry ? null : (isEdit ? getValues('applicant_new.score_localization') || '' : ''));
  }, [showVehicleRegistry]);

  if (![PROCEDURE_TYPE.PROCEDURE_1227_6].includes(procedure)) {
    return null;
  }

  return (
    <>
      <div className="f4 mt-3">Основание внесения ТС в Реестр ЛТ</div>
      <Row className="row-cols-1">
        <FieldDTO
          control={control}
          component={CustomSelectInput}
          dtoObject={{
            name: 'applicant_exemption',
            type: String,
            validators: [],
            labelKey: 'applicant.exemption',
          }}
          usePortal
          variant="material"
          withLabel
          options={applicantType !== USER_TYPE.PRIVATE_PERSON ? VEHICLE_REGISTRY_BASIS_LIST.filter(e => e.value !== VEHICLE_REGISTRY_BASIS_TYPE.EXEMPTION_2) : VEHICLE_REGISTRY_BASIS_LIST}
          addPlaceholder
        />
      </Row>
      {showVehicleRegistry && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={{
              name: 'score_localization',
              type: String,
              validators: [],
              labelKey: 'score_localization',
            }}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new."
          />
        </Row>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
